var map = {
	"./micro-frontend/pages/boleta-upload/boleta-upload.module.ngfactory": [
		"./src/app/micro-frontend/pages/boleta-upload/boleta-upload.module.ngfactory.js",
		"common",
		"micro-frontend-pages-boleta-upload-boleta-upload-module-ngfactory"
	],
	"./micro-frontend/pages/cda-hidden/cda-hidden.module.ngfactory": [
		"./src/app/micro-frontend/pages/cda-hidden/cda-hidden.module.ngfactory.js",
		"common",
		"micro-frontend-pages-cda-hidden-cda-hidden-module-ngfactory"
	],
	"./micro-frontend/pages/gestao-de-caixa/gestao-de-caixa.module.ngfactory": [
		"./src/app/micro-frontend/pages/gestao-de-caixa/gestao-de-caixa.module.ngfactory.js",
		"default~micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory~micro-frontend-pages-m~d94367d9",
		"common",
		"micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory"
	],
	"./micro-frontend/pages/justificar-ativos/justificar-ativos.module.ngfactory": [
		"./src/app/micro-frontend/pages/justificar-ativos/justificar-ativos.module.ngfactory.js",
		"common",
		"micro-frontend-pages-justificar-ativos-justificar-ativos-module-ngfactory"
	],
	"./micro-frontend/pages/motor-relatorio/motor-relatorio.module.ngfactory": [
		"./src/app/micro-frontend/pages/motor-relatorio/motor-relatorio.module.ngfactory.js",
		"default~micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory~micro-frontend-pages-m~d94367d9",
		"common",
		"micro-frontend-pages-motor-relatorio-motor-relatorio-module-ngfactory"
	],
	"./micro-frontend/pages/status-liquidacao/status-liquidacao.module.ngfactory": [
		"./src/app/micro-frontend/pages/status-liquidacao/status-liquidacao.module.ngfactory.js",
		"common",
		"micro-frontend-pages-status-liquidacao-status-liquidacao-module-ngfactory"
	],
	"./micro-frontend/pages/upload-arquivos/upload-arquivos.module.ngfactory": [
		"./src/app/micro-frontend/pages/upload-arquivos/upload-arquivos.module.ngfactory.js",
		"common",
		"micro-frontend-pages-upload-arquivos-upload-arquivos-module-ngfactory"
	],
	"./pages/users/users.module.ngfactory": [
		"./src/app/pages/users/users.module.ngfactory.js",
		"pages-users-users-module-ngfactory"
	],
	"./quota-status/quota-status.module.ngfactory": [
		"./src/app/quota-status/quota-status.module.ngfactory.js",
		"common",
		"quota-status-quota-status-module-ngfactory"
	],
	"./shares/shares.module.ngfactory": [
		"./src/app/shares/shares.module.ngfactory.js",
		"common",
		"shares-shares-module-ngfactory"
	],
	"./trade-status/trade-status.module.ngfactory": [
		"./src/app/trade-status/trade-status.module.ngfactory.js",
		"common",
		"trade-status-trade-status-module-ngfactory"
	],
	"src/app/micro-frontend/pages/boleta-upload/boleta-upload.module.ngfactory": [
		"./src/app/micro-frontend/pages/boleta-upload/boleta-upload.module.ngfactory.js",
		"common",
		"micro-frontend-pages-boleta-upload-boleta-upload-module-ngfactory"
	],
	"src/app/micro-frontend/pages/cda-hidden/cda-hidden.module.ngfactory": [
		"./src/app/micro-frontend/pages/cda-hidden/cda-hidden.module.ngfactory.js",
		"common",
		"micro-frontend-pages-cda-hidden-cda-hidden-module-ngfactory"
	],
	"src/app/micro-frontend/pages/gestao-de-caixa/gestao-de-caixa.module.ngfactory": [
		"./src/app/micro-frontend/pages/gestao-de-caixa/gestao-de-caixa.module.ngfactory.js",
		"default~micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory~micro-frontend-pages-m~d94367d9",
		"common",
		"micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory"
	],
	"src/app/micro-frontend/pages/motor-relatorio/motor-relatorio.module.ngfactory": [
		"./src/app/micro-frontend/pages/motor-relatorio/motor-relatorio.module.ngfactory.js",
		"default~micro-frontend-pages-gestao-de-caixa-gestao-de-caixa-module-ngfactory~micro-frontend-pages-m~d94367d9",
		"common",
		"micro-frontend-pages-motor-relatorio-motor-relatorio-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;